/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsDailyBenefitQuery from '../graphql/queries/GetSimulationPricingsDailyBenefitQuery.js';

const useGetSimulationPricingsDailyBenefitQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsDailyBenefitQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsDailyBenefit: R.omit(['__typename'], data?.getSimulationPricingsDailyBenefit_simulation_pricings_daily_benefit || {})
  };
};

export default useGetSimulationPricingsDailyBenefitQuery;
